import { render } from "./TableTabletFormComponentDetails.vue?vue&type=template&id=650d81fa"
import script from "./TableTabletFormComponentDetails.vue?vue&type=script&lang=js"
export * from "./TableTabletFormComponentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__